import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';
import { Direction } from 'webapp/enums/enums';

import onHoverPopup from 'webapp/modifiers/on-hover-popup';
import BlockPopupMediaComponent from 'webapp/components/block/popup-media';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import LoaderSvgComponent from 'webapp/components/loader-svg';

import type { AggregationCell, TableStructureCell } from 'webapp/models-custom/visualization/table';
import DChartPrimaryPoint from 'webapp/d-chart/point/primary-point';

interface Args {
	mediaUrl?: string;
	label: string;
	cells: (TableStructureCell | AggregationCell)[];
	isOther?: boolean;
}

export default class BlockContentTableMediaLabelComponent extends Component<Args> {
	@service('popup') declare popupService: Service.Popup;

	get mediaUrl() {
		return this.args.mediaUrl;
	}

	get label() {
		return this.args.label;
	}

	get isMediaUrlEmpty() {
		return !this.args.mediaUrl;
	}

	// for media creatives images loading status
	get isMediaLoading() {
		return (
			!this.args.isOther &&
			this.args.cells.some((cell) => {
				return cell.points.some(
					(point) => point instanceof DChartPrimaryPoint && point?.mediaLoading,
				);
			})
		);
	}

	@action
	openPopup(node: HTMLElement) {
		if (this.isMediaUrlEmpty) {
			return;
		}

		const popup = this.popupService.createContext(BlockPopupMediaComponent, node, {
			popupClass: 'popup-type-media',
			directions: [Direction.RIGHT, Direction.LEFT, Direction.UP, Direction.DOWN],
			// offset because of hidden arrow
			offset: 6,
			hideArrow: true,
			allowMultipleInstances: true,
		});

		popup.open({
			mediaUrl: this.mediaUrl ?? '',
			label: this.label,
		});

		return popup;
	}
	<template>
		<div class="bc__media" {{onHoverPopup this.openPopup 100}}>
			{{#if this.mediaUrl}}
				{{#if this.isMediaLoading}}
					<LoaderSvgComponent />
				{{/if}}
				<img src={{this.mediaUrl}} alt={{this.label}} />
			{{else if this.isMediaLoading}}
				<div class="bc__media--empty">
					<LoaderSvgComponent />
				</div>
			{{else}}
				<div class="bc__media--empty">
					<CommonUiIconComponent @name="Image" @size="sm" />
				</div>
			{{/if}}
		</div>
	</template>
}
